import React, { Component } from "react";

export default class Datenschutz extends Component {
  componentDidMount() {
    window.scrollTo({ top: 0, behavior: "instant" });
  }

  render() {
    return (
      <div className="section-container">
        <div className="padding-block-500">
          <div className="container">
            <div className="padding-block-500">
              <div className="misc-heading">
                Datenschutz – Das Wichtigste auf einen Blick
              </div>
              <br />
              <div className="misc-paragraph">
                <p>
                  Wir sind verpflichtet, Sie darüber zu informieren, warum und
                  wie wir Ihre Daten auf dieser Webseite sammeln und verwenden.
                  Wenn Sie Fragen haben, können Sie sich jederzeit an uns
                  wenden.
                </p>
                <br />
                <h2 className="fw-bold">Was sind personenbezogene Daten?</h2>
                <p>
                  Das sind Informationen, die sich auf eine bestimmte Person
                  beziehen, zum Beispiel Ihr Name, Ihre Adresse, Telefonnummer
                  oder Geburtsdatum. Auch Daten darüber, wie Sie unsere Webseite
                  nutzen, können dazu gehören.
                </p>
                <br />
                <h2 className="fw-bold">Wie wir die Webseite bereitstellen:</h2>
                <p>
                  Unser Server sammelt keine persönlichen Daten, wenn Sie die
                  Seite besuchen. Es gibt aber Sicherheits-Plugins, die unsere
                  Webseite vor Angriffen schützen. Wenn es einen Verdacht auf
                  einen Angriff gibt, werden bestimmte Daten automatisch
                  gespeichert, zum Beispiel Ihre IP-Adresse, Datum und Uhrzeit,
                  Browser-Informationen und warum der Verdacht besteht.
                </p>
                <br />
                <h3 className="fw-bold">Warum wir diese Daten sammeln:</h3>
                <p>
                  Wir nutzen diese Daten, um Angriffe abzuwehren, die Sicherheit
                  der Webseite zu gewährleisten und bei Problemen nachzusehen.
                </p>
                <br />
                <h3 className="fw-bold">Rechtsgrundlage</h3>
                <p>
                  Das ist gemäß der Datenschutzgesetze (Artikel 6, Absatz 1,
                  Buchstabe f DSGVO).
                </p>
                <br />
                <h3 className="fw-bold">Warum wir diese Daten brauchen:</h3>
                <p>
                  Wir brauchen sie, um die Webseite sicher und stabil zu halten.
                </p>
                <br />
                <h3 className="fw-bold">Wie lange wir die Daten speichern:</h3>
                <p>
                  Die Daten werden gelöscht, wenn sie nicht mehr benötigt
                  werden. Das ist meistens nach 72 Stunden.
                </p>
                <br />
                <h3 className="fw-bold">Widerspruch:</h3>
                <p>
                  Da die Daten für den Betrieb der Webseite notwendig sind,
                  können Sie dagegen nichts einwenden.
                </p>
                <br />
                <h2 className="fw-bold">
                  Rechtsgrundlagen für die Verarbeitung Ihrer Daten:
                </h2>
                <ul>
                  <li>
                    <p>
                      Wenn Sie uns Ihre Zustimmung geben, verwenden wir Ihre
                      Daten basierend auf Art. 6 Abs. 1 S. 1 lit. a DSGVO.
                    </p>
                  </li>
                  <br />
                  <li>
                    <p>
                      Wenn wir einen Vertrag mit Ihnen erfüllen, ist die
                      Grundlage Art. 6 Abs. 1 S. 1 lit. b DSGVO.
                    </p>
                  </li>
                  <br />
                  <li>
                    <p>
                      Für gesetzliche Verpflichtungen verwenden wir Art. 6 Abs.
                      1 S. 1 lit. c DSGVO.
                    </p>
                  </li>
                  <br />
                  <li>
                    <p>
                      Wenn wir Ihre Daten zur Wahrung unserer berechtigten
                      Interessen nutzen, basiert das auf Art. 6 Abs. 1 S. 1 lit.
                      f DSGVO.
                    </p>
                  </li>
                  <br />
                  <h2 className="fw-bold">
                    Wie lange speichern wir Ihre Daten?
                  </h2>
                  <p>
                    Wir löschen oder sperren Ihre Daten, sobald der Zweck
                    erfüllt ist, meist nach 72 Stunden, oder wenn gesetzliche
                    Vorgaben eine längere Speicherung vorschreiben.
                  </p>
                </ul>
                <br />
                <h2 className="fw-bold">Cookies:</h2>
                <p>
                  Cookies sind kleine Dateien, die auf Ihrem Computer
                  gespeichert werden, um bestimmte Einstellungen zu merken, z.B.
                  Ihre Sprache oder Besuchsdauer.
                </p>
                <br />
                <ul>
                  <li>
                    <p>
                      Erforderliche Cookies sind notwendig für den Betrieb der
                      Webseite und werden meist durch unsere Webseite gesetzt.
                    </p>
                  </li>
                  <br />
                  <li>
                    <p>
                      Sie können Cookies jederzeit löschen oder in Ihrem Browser
                      blockieren, aber dann funktioniert die Webseite
                      möglicherweise nicht mehr richtig.
                    </p>
                  </li>
                  <br />
                </ul>
                <br />
                <h3 className="fw-bold">Kontaktaufnahme:</h3>
                <p>
                  Wenn Sie uns freiwillig Ihre Daten mitteilen, z.B. per E-Mail
                  oder Kontaktformular, verwenden wir diese nur, um Ihr Anliegen
                  zu bearbeiten.
                </p>
                <br />
                <ul>
                  <li>
                    <p>
                      Wir löschen Ihre Daten, sobald wir Ihre Anfrage
                      vollständig geklärt haben.
                    </p>
                  </li>
                  <br />
                  <li>
                    <p>
                      Sie können jederzeit die Löschung Ihrer Daten verlangen,
                      indem Sie unseren Datenschutzbeauftragten kontaktieren.
                    </p>
                  </li>
                  <br />
                </ul>
                <br />
                <h3 className="fw-bold">Datenweitergabe an Dritte:</h3>
                <p>
                  Wir geben Ihre Daten nur weiter, wenn wir dazu gesetzlich
                  verpflichtet sind oder Sie eingewilligt haben. Unsere
                  Dienstleister sind vertraglich verpflichtet, die
                  Datenschutzregeln einzuhalten.
                </p>
                <br />
                <h3 className="fw-bold">Ihre Rechte:</h3>
                <p>
                  Sie haben das Recht, Auskunft über Ihre bei uns gespeicherten
                  Daten zu erhalten, sie zu berichtigen, zu löschen oder die
                  Verarbeitung einzuschränken. Sie können auch Widerspruch gegen
                  die Verarbeitung einlegen oder eine Beschwerde bei einer
                  Datenschutzbehörde einreichen.
                </p>
                <br />
                <h2 className="fw-bold">Verantwortliche Stelle:</h2>
                <p>
                  Schrader Beratung GmbH, Waldstr. 18a, 04924 Bad Liebenwerda
                  Unser Datenschutzbeauftragter ist erreichbar unter{" "}
                  <a
                    style={{ color: "blue" }}
                    href="mailto:datenschutz@schrader-beratung.de">
                    datenschutz@schrader-beratung.de
                  </a>
                  .
                </p>
                <br />
                <h3 className="fw-bold">Links zu anderen Webseiten:</h3>
                <p>
                  Unsere Webseite kann Links zu anderen Anbietern enthalten. Für
                  deren Datenschutz gelten deren eigene Hinweise.
                </p>
                <br />
                <h3 className="fw-bold">Änderungen:</h3>
                <p>
                  Wir können diese Datenschutzhinweise jederzeit anpassen.
                  Stand: Januar 2025.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
